// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file daiConnectorConfig/daiConnectorConfig.proto (package daiConnectorConfig, syntax proto3)
/* eslint-disable */

import type { BigIntString, BytesString } from "../runtime";
import { RPC } from "../runtime";

/**
 * @generated from message daiConnectorConfig.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * Upload Request - streaming with metadata in first chunk
 *
 * @generated from message daiConnectorConfig.UploadDaiConfigFileRequest
 */
export type UploadDaiConfigFileRequest = {
/**
 * Metadata fields (only set in first message)
 *
 * @generated from field: string file_name = 1;
 */
fileName?: string;
/**
 * Username who created the file
 *
 * @generated from field: string created_by = 2;
 */
createdBy?: string;
/**
 * Unix timestamp
 *
 * @generated from field: int64 created_at = 3;
 */
createdAt?: BigIntString;
/**
 * Optional, defaults to env variable
 *
 * @generated from field: string bucket_name = 4;
 */
bucketName?: string;
/**
 * File chunk data (set in all messages including first if it contains data)
 *
 * @generated from field: bytes chunk = 5;
 */
chunk?: BytesString;
/**
 * @generated from field: daiConnectorConfig.UserContext user_context = 6;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message daiConnectorConfig.UploadDaiConfigFileResponse
 */
export type UploadDaiConfigFileResponse = {
/**
 * @generated from field: bool success = 1;
 */
success?: boolean;
/**
 * @generated from field: string message = 2;
 */
message?: string;
}
;
/**
 * List Files
 *
 * @generated from message daiConnectorConfig.ListDaiConfigFilesRequest
 */
export type ListDaiConfigFilesRequest = {
/**
 * Optional, defaults to env variable
 *
 * @generated from field: string bucket_name = 1;
 */
bucketName?: string;
/**
 * @generated from field: daiConnectorConfig.UserContext user_context = 2;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message daiConnectorConfig.DaiConfigFileInfo
 */
export type DaiConfigFileInfo = {
/**
 * @generated from field: string file_name = 1;
 */
fileName?: string;
/**
 * File size in bytes
 *
 * @generated from field: int64 size = 2;
 */
size?: BigIntString;
/**
 * Unix timestamp
 *
 * @generated from field: int64 created_at = 3;
 */
createdAt?: BigIntString;
/**
 * Username who created the file
 *
 * @generated from field: string created_by = 4;
 */
createdBy?: string;
}
;
/**
 * @generated from message daiConnectorConfig.ListDaiConfigFilesResponse
 */
export type ListDaiConfigFilesResponse = {
/**
 * @generated from field: repeated daiConnectorConfig.DaiConfigFileInfo files = 1;
 */
files?: DaiConfigFileInfo[];
}
;
/**
 * Get File Content
 *
 * @generated from message daiConnectorConfig.GetDaiConfigFileContentRequest
 */
export type GetDaiConfigFileContentRequest = {
/**
 * @generated from field: string file_name = 1;
 */
fileName?: string;
/**
 * Optional, defaults to env variable
 *
 * @generated from field: string bucket_name = 2;
 */
bucketName?: string;
/**
 * @generated from field: daiConnectorConfig.UserContext user_context = 3;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message daiConnectorConfig.GetDaiConfigFileContentResponse
 */
export type GetDaiConfigFileContentResponse = {
/**
 * @generated from field: bool success = 1;
 */
success?: boolean;
/**
 * File content as string
 *
 * @generated from field: string content = 2;
 */
content?: string;
/**
 * Error message if any
 *
 * @generated from field: string message = 3;
 */
message?: string;
/**
 * Metadata about the file
 *
 * @generated from field: daiConnectorConfig.DaiConfigFileInfo file_info = 4;
 */
fileInfo?: DaiConfigFileInfo;
}
;
/**
 * Delete Files
 *
 * @generated from message daiConnectorConfig.DeleteDaiConfigFilesRequest
 */
export type DeleteDaiConfigFilesRequest = {
/**
 * @generated from field: repeated string file_names = 1;
 */
fileNames?: string[];
/**
 * Optional, defaults to env variable
 *
 * @generated from field: string bucket_name = 2;
 */
bucketName?: string;
/**
 * @generated from field: daiConnectorConfig.UserContext user_context = 3;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message daiConnectorConfig.DeleteDaiConfigFilesResponse
 */
export type DeleteDaiConfigFilesResponse = {
/**
 * @generated from field: bool success = 1;
 */
success?: boolean;
/**
 * @generated from field: string message = 2;
 */
message?: string;
/**
 * Successfully deleted file names
 *
 * @generated from field: repeated string deleted_names = 3;
 */
deletedNames?: string[];
/**
 * Failed to delete file names
 *
 * @generated from field: repeated string failed_names = 4;
 */
failedNames?: string[];
}
;
/**
 * Upload a config file with metadata
 *
 * @generated from rpc daiConnectorConfig.DaiConnectorConfigService.UploadDaiConfigFile
 */
export const DaiConnectorConfigService_UploadDaiConfigFile = new RPC<UploadDaiConfigFileRequest,UploadDaiConfigFileResponse>("POST", "/api/dai-config/upload");
/**
 * List all config files with metadata
 *
 * @generated from rpc daiConnectorConfig.DaiConnectorConfigService.ListDaiConfigFiles
 */
export const DaiConnectorConfigService_ListDaiConfigFiles = new RPC<ListDaiConfigFilesRequest,ListDaiConfigFilesResponse>("POST", "/api/dai-config/list");
/**
 * Get file content as a string
 *
 * @generated from rpc daiConnectorConfig.DaiConnectorConfigService.GetDaiConfigFileContent
 */
export const DaiConnectorConfigService_GetDaiConfigFileContent = new RPC<GetDaiConfigFileContentRequest,GetDaiConfigFileContentResponse>("POST", "/api/dai-config/content");
/**
 * Delete one or more config files
 *
 * @generated from rpc daiConnectorConfig.DaiConnectorConfigService.DeleteDaiConfigFiles
 */
export const DaiConnectorConfigService_DeleteDaiConfigFiles = new RPC<DeleteDaiConfigFilesRequest,DeleteDaiConfigFilesResponse>("POST", "/api/dai-config/delete");
